import { render } from "./new-notification-client.vue?vue&type=template&id=3fff47bc"
import script from "./new-notification-client.vue?vue&type=script&lang=js"
export * from "./new-notification-client.vue?vue&type=script&lang=js"

import "./new-notification-client.vue?vue&type=style&index=0&id=3fff47bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__